import { useLingui } from '@lingui/react/macro';
import { NOTIFICATION_TYPE_LABELS } from 'modules/notifications/domain/const';
import React from 'react';
import { udCardClassName } from 'ud-ui/components/card';
import { UDSkeletonLabel, UDSkeletonText } from 'ud-ui/components/skeleton';
import { UD_ICON_TILE_METRICS } from 'ud-ui/components/icon-tile';
import { UD_STATUS_BADGE_METRICS } from 'ud-ui/components/status-badge';
import {
  NOTIFICATION_BODY_LAYOUT,
  NOTIFICATION_CARD_LAYOUT,
  NOTIFICATION_HEADER_LAYOUT,
  NOTIFICATION_TEXT_BLOCK,
} from './notification-layout';

/** Скелетон карточки уведомления: те же поля, радиус, плитка и бейдж, что у `NotificationComponent`. */
const NotificationSkeleton: React.FC = () => {
  const { t } = useLingui();

  return (
    <div className={`${udCardClassName()} ${NOTIFICATION_CARD_LAYOUT}`} aria-hidden>
      <div
        className={`skeleton-block ${UD_ICON_TILE_METRICS.className}`}
        style={{ width: UD_ICON_TILE_METRICS.size, height: UD_ICON_TILE_METRICS.size }}
      />
      <div className={NOTIFICATION_BODY_LAYOUT}>
        <div className={NOTIFICATION_HEADER_LAYOUT}>
          <UDSkeletonText type="subhead" className="w-48" />
          <UDSkeletonLabel
            label={t(NOTIFICATION_TYPE_LABELS.update)}
            className={UD_STATUS_BADGE_METRICS.sm.className}
            variant={UD_STATUS_BADGE_METRICS.sm.variant}
          />
        </div>
        {/* Самое частое уведомление — одна строка текста. */}
        <div className={NOTIFICATION_TEXT_BLOCK}>
          <UDSkeletonText type="subhead" className="w-2/3" />
        </div>
      </div>
    </div>
  );
};

interface NotificationSkeletonListProps {
  count?: number;
}

/** Колонка скелетонов с тем же шагом, что у списка карточек: её же берёт «Сверка скелетона» поверх экрана. */
export const NotificationSkeletonList: React.FC<NotificationSkeletonListProps> = ({ count = 5 }) => (
  <div className="flex flex-col gap-3">
    {Array.from({ length: count }).map((_, index) => (
      <NotificationSkeleton key={index} />
    ))}
  </div>
);

export default NotificationSkeleton;
